import React, { useContext, useState } from "react";
import Layout from "../../components/global/Layout";
import { Container } from "react-bootstrap";
import { createMatcher } from "../../faceUtil";
import { _rest, Notification } from '../../services/api';
import { AuthContext } from "../../context";
import Button from '@mui/material/Button';
import { useHistory } from "react-router-dom";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useGeolocated } from "react-geolocated";
import GeoLocation from './GeoLocation'

import ProcessFaceRecognition from "./ProcessFaceRecognition";
var LoaderIcon = require("../../assets/icons/loader-dot.svg");

function FaceScan() {
   const { user, logout } = useContext(AuthContext);
   const [participants, setParticipants] = useState([]);
   const [facePhotos, setFacePhotos] = useState([]);
   const [faceMatcher, setFaceMatcher] = useState(null);
   const threshold = 0.45;
   const [isDataLoading, setIsDataLoading] = React.useState(true);
   const history = useHistory();
   
   React.useEffect(() => {
      if (!user?.['facility_id'] && !user?.['scan_type']) {
         goToALiv();
         Notification('Please login with aliv dashboard again', '', 'danger')
      } else {
         fetchUserFacePhotos()
      }
   }, [])

   const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({ positionOptions: { enableHighAccuracy: true }, userDecisionTimeout: 5000 });
   const GeoLocationData = { coords, isGeolocationAvailable, isGeolocationEnabled };

   // fetch specific user face vectors
   const fetchUserFacePhotos = async () => {
      setIsDataLoading(true);
      try {
         const res = await _rest.fetchAllFaces(user?.user_id);
         if (res?.success) {
            setFacePhotos(res?.data?.faceVectors);
            setParticipants(res.data?.participants);
            if (res?.data?.faceVectors?.length > 0) {
               const validMatcher = res.data?.participants?.filter((m) => m?.facePhotos?.length > 0);
               const profileList = await createMatcher(validMatcher, threshold);
               setFaceMatcher(profileList);
            }
         }
      } catch (error) {
         if (error.status === 401) {
            logout();
         }
      }
      setIsDataLoading(false);
   };


   const goToALiv = () => {
      history.push('/face-gallery')
   }

   return (
      <Layout styleId="face-scan-root">
         <Container >
            <section id="user-face-scan-box">
               {isDataLoading ? (
                  <div className="loader">
                     <div>
                        <img src={LoaderIcon} alt="" />
                        <h6>Please wait</h6>
                     </div>
                  </div>
               ) :
                  (
                     facePhotos?.length === 0 ? (
                        <div className="loader">
                           <div className="no-img">
                              <h5>No face uploaded for matching</h5>
                              <h6>Please upload minimum 5 face images <br /> for better face recognition</h6>
                              <Button variant="contained" onClick={goToALiv} >
                                 Upload face image <CloudUploadIcon />
                              </Button>
                           </div>
                        </div>
                     ) : (
                        (isGeolocationAvailable && isGeolocationEnabled && coords?.longitude) ? (
                           < ProcessFaceRecognition
                              // {...props}
                              faceMatcher={faceMatcher}
                              facePhotos={facePhotos}
                              participants={participants}
                              GeoLocationData={GeoLocationData}
                              user={user}
                           />) : (
                           <div className="geo-location loader">
                              <div>
                                 <GeoLocation GeoLocationData={GeoLocationData} />
                              </div>
                           </div>
                        )
                     )
                  )
               }
            </section>
         </Container>
      </Layout >
   );
}

export default FaceScan;
